var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentheses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55728 3.37542C7.76469 3.01688 7.64217 2.55808 7.28362 2.35068C6.92508 2.14327 6.46628 2.26579 6.25887 2.62434C4.66309 5.38298 3.75 8.58593 3.75 11.9999C3.75 15.4138 4.66309 18.6168 6.25887 21.3754C6.46628 21.734 6.92508 21.8565 7.28362 21.6491C7.64217 21.4417 7.76469 20.9829 7.55728 20.6243C6.09001 18.0879 5.25 15.1431 5.25 11.9999C5.25 8.85666 6.09001 5.91191 7.55728 3.37542Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4427 3.37542C16.2353 3.01688 16.3578 2.55808 16.7164 2.35068C17.0749 2.14327 17.5337 2.26579 17.7411 2.62434C19.3369 5.38298 20.25 8.58593 20.25 11.9999C20.25 15.4138 19.3369 18.6168 17.7411 21.3754C17.5337 21.734 17.0749 21.8565 16.7164 21.6491C16.3578 21.4417 16.2353 20.9829 16.4427 20.6243C17.91 18.0879 18.75 15.1431 18.75 11.9999C18.75 8.85666 17.91 5.91191 16.4427 3.37542Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentheses);
export default __webpack_public_path__ + "static/media/parentheses.e3870421bca9a2dc468635c51872d059.svg";
export { ForwardRef as ReactComponent };